module.exports = __webpack_public_path__ + "img/10-7CM.d073f00.jpg";